<template>
  <v-alert dark color="alartGentle" class="cookieconsent" :value="!cookieConsented">
    {{ $t("message") }}
    <v-btn dark text :to="{name: 'termsOfUse', params:{  locale: $i18n.locale}}">{{ $t("privacyPolicy") }}</v-btn>
    <v-btn text color="highlight" @click="declineTracking">{{ $t("decline") }}</v-btn>
    <v-btn light color="highlight" @click="consentTracking">{{ $t("checked") }}</v-btn>
  </v-alert>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "cookieConsent",
  computed: mapState(["cookieConsented"]),
  methods: {
    declineTracking() {
      this.$gtag.optOut();
      this.$store.commit("trackingAllowed", false);
      this.$store.commit("cookieConsented", true);
    },
    consentTracking() {
      this.$gtag.optIn();
      this.$store.commit("trackingAllowed", true);
      this.$store.commit("cookieConsented", true);
    }
  }
};
</script>

<i18n>
{
  "en": {
    "message": "This website uses cookies to improve websites, services and advertising.",
    "decline": "Decline",
    "privacyPolicy":"Check Privacy Policy",
    "checked":"Got it!"
  },
  "ja": {
    "message": "このサイトでは、サイト・サービス・広告を改善するためにCookieを利用します。",
    "decline": "拒否する",
    "privacyPolicy":"プライバシーポリシーを確認",
    "checked":"確認した"
  }
}
</i18n>

<style scoped>
.cookieconsent {
  position: fixed;
  z-index: 1000;
  bottom: 10px;
  width: 95%;
  margin: 2.5%;
  text-align: center;
}
</style>
